module.exports = __webpack_public_path__ + "img/bild_kontakt.dcd73406.gif";